import moment from 'moment-jalaali'
import config from 'SrcConfig'

export const jalaaliYear = (date) => {
  if (date) return moment(date).format('jYYYY')
  return date
}

export const jalaaliWeekDayName = (date) => {
  if (date) return moment(date).locale('fa').format('dddd')
  return date
}

export const jalaaliFullDate = (date) => {
  if (date) return moment(date).format('jYYYY/jMM/jDD')
}

export const jalaaliTime = (date) => {
  if (date) return moment(date).format('HH:mm')
  return date
}

export const jalaaliFullDateTime = (date) => {
  if (date) {
    return date === config.infinityTime
      ? '∞'
      : `${jalaaliFullDate(date)} - ${jalaaliTime(date)}`
  }
  return date
}

export const jalaaliTimeWithSecs = (date) => {
  if (date) return moment(date).format('HH:mm:ss')
  return date
}

export const ssToHhMm = (second) => {
  if (second === null || second === '') return null

  second = Number(second)

  const minutes = Math.floor(second / 60)
  second = second % 60
  return {
    hour: Math.floor(minutes / 60) || null,
    minutes: minutes % 60 || null
  }
}

export const convertToDateTimeZone = (date, time) => {
  const miladiFullDate = moment(`${date} ${time}`, 'YYYY/M/D HH:mm').format(
    'YYYY/MM/DD HH:mm:ss'
  )
  return moment(miladiFullDate).utc().format()
}
